module.exports = __webpack_public_path__ + "img/shr_logo.c099379d.png";